import React from 'react';
import { Box, Button, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import psTheme, { backdrop, surfaces } from '../ps/psTheme';
import '../ps/ps-tokens.css';
import '../ps/learn.css';
import pslogo from './pslogo.png';

const NotFound = () => (
  <ThemeProvider theme={psTheme}>
    <CssBaseline />
    <Box
      sx={{
        ...backdrop,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: '10px',
        fontFamily: 'var(--ps-font)',
      }}
    >
      <Box
        sx={{
          ...surfaces.panel,
          p: '22px',
          maxWidth: 420,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <img src={pslogo} alt="Phil Speiser" style={{ height: 18, marginBottom: 12 }} />
        <span className="ps-value" style={{ fontSize: 22 }}>404</span>
        <span className="ps-label ps-label--dim">This page does not exist</span>
        <Button variant="contained" href="/" sx={{ mt: '10px' }}>
          Back to the videos
        </Button>
      </Box>
    </Box>
  </ThemeProvider>
);

export default NotFound;
